import { getPaginationSchema } from 'src/components/form/zod-schemas';
import { useNow } from 'src/hooks/use-now';
import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { useAuctionLivePageParams } from 'src/pages/transport/network-points/details/point-details/auction-live-table';
import { getTradeProposalsPageParamsSchema } from 'src/pages/transport/secondary-trading/overview/tso/schema';

const favouriteNetworkPointsSchema = getPaginationSchema({ pageSize: 5 });

export function useDashboardPageParams() {
  const favouriteNetworkPoints = usePageParamsFromSchema(
    favouriteNetworkPointsSchema,
    { groupPrefix: 'favouriteNetworkPoints' }
  );

  const auctionLive = useAuctionLivePageParams();

  return {
    favouriteNetworkPoints,
    auctionLive,
  };
}

export type DashboardPageParams = ReturnType<typeof useDashboardPageParams>;

export const useOwnTradeProposalsPageParams = () => {
  const now = useNow();

  return usePageParamsFromSchema(
    getTradeProposalsPageParamsSchema(now, { pageSize: 5 }),
    {
      groupPrefix: 'ownTradeProposals',
    }
  );
};

export const useProposalsFavouriteNetworkPointPageParams = () => {
  const now = useNow();

  return usePageParamsFromSchema(
    getTradeProposalsPageParamsSchema(now, { pageSize: 5 }),
    {
      groupPrefix: 'proposalsFavouriteNetworkPoint',
    }
  );
};
